
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"search.exact":"exact","search.fuzzy":"fuzzy","search.placeholder":"Enter search term"},"de":{"search.exact":"exakt","search.fuzzy":"unscharf","search.placeholder":"Suchbegriff eingeben"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();